import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type SaveMaterialsListArgs = {
    bundleId: number;
    selectedMaterials: Material[];
};

export const saveMaterialsList = ({ selectedMaterials, bundleId }: SaveMaterialsListArgs) => {
    const materials = selectedMaterials.map((material) => material.id);
    const partition = bundleId ? `${bundleId}/materials` : 'create';

    return axios.post(`${API_URLS.BUNDLE}/${partition}`, { materials });
};
